import {Link} from '@nlabs/gothamjs/router';

import type {ReactElement} from 'react';

const mark = new URL('../../assets/reactorbox-mark.png', import.meta.url).href;
const linkClass = 'rounded-sm text-white/65 transition-colors hover:text-sky-200 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-sky-300';

export const SiteFooter = ({signedIn = false}: {readonly signedIn?: boolean}): ReactElement => {
  const footerGroups = [
    {
      links: [
        {href: '/features', label: 'Features'},
        {href: '/videos', label: 'Quick video'},
        {href: '/projects', label: 'Story projects'},
        {href: '/pricing', label: 'Plans & pricing'}
      ],
      title: 'Services'
    },
    {
      links: [
        {href: '/privacy', label: 'Privacy'},
        {href: '/terms', label: 'Terms of service'}
      ],
      title: 'Legal'
    }
  ];
  return (
    <footer className="mt-16 border-t border-violet-300/15 bg-[#09070f] px-5 pt-12 pb-7 text-white sm:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-2 gap-x-7 gap-y-10 border-b border-white/10 pb-10 md:grid-cols-[minmax(220px,1.4fr)_repeat(2,minmax(120px,1fr))] md:gap-10">
          <div className="col-span-2 max-w-xs md:col-span-1">
            <Link aria-label={signedIn ? 'Reactorbox dashboard' : 'Reactorbox home'} className="inline-flex items-center gap-2 rounded-sm font-heading text-xl font-semibold tracking-tight focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-sky-300" to={signedIn ? '/projects' : '/'}>
              <img alt="" className="size-8 object-contain" src={mark} />reactorbox
            </Link>
            <p className="mt-4 text-sm leading-6 text-white/55">Make something worth watching. A creative home for quick videos and your next great story.</p>
          </div>
          {footerGroups.map(({links, title}) => (
            <nav aria-label={`${title} links`} key={title}>
              <h2 className="m-0 text-[10px] font-bold tracking-[.14em] text-violet-300 uppercase">{title}</h2>
              <ul className="mt-4 grid list-none gap-2.5 p-0 text-sm">
                {links.map(({href, label}) => (
                  <li key={href}><Link className={linkClass} to={href}>{label}</Link></li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
        <div className="flex flex-col gap-2 pt-6 text-xs leading-5 text-white/45 sm:flex-row sm:items-center sm:justify-between">
          <p className="m-0">© {new Date().getFullYear()} <a className="rounded-sm underline decoration-white/25 underline-offset-4 transition-colors hover:text-sky-200 focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-sky-300" href="https://nitrogenx.co">Nitrogen Labs, Inc.</a> All rights reserved.</p>
          <p className="m-0">Make something worth watching.</p>
        </div>
      </div>
    </footer>
  );
};
